// extracted by mini-css-extract-plugin
module.exports = {"main":"OutdatedVersionScreen_main__9v24z","link":"OutdatedVersionScreen_link__3DDiA","logout":"OutdatedVersionScreen_logout__3EZ6B"};